import React, { Component } from 'react';
import { DOMAIN } from '../config';
import Footer from '../components/Footer.jsx';
import Navbar from '../components/Navbar.jsx';
import Jumbotron from '../components/Jumbotron.jsx';


class About extends Component {

  
   
  render() {      

    return (
        <div style={{'background-color': ""}}>
          <div style={{'width':'100%', 'height': "100px", 'backgroundColor': '#f1a38e', 'color': 'white', fontSize: '45px'}}><p style={{'marginLeft':'7%'}}>About us</p></div>
          <div className="container" style={{'minHeight': "550px", marginTop: '2%'}}>
          <p>भारत हमेशा से ही आध्यात्मिक शक्तियों का शिरमौर रहा है l यहां सदेव ही महान विभूतियों का अवतरण होता रहा है l उन लोगों ने अपने दिव्य ज्ञान व पराविद्या 
से न सिर्फ भारत को बल्कि पूरे संसार को प्रकाशमय किया है l</p>
<p>यहां की विभूतियां पूरे संसार को अपने इशारे पर नचाया करती है - त्रेतायुग में जब रावण जैसे आततायी से धरती कांप उठी तो भगवान राम ने उसका सम्पूर्ण विनाश कर के धरती पर धर्म और शांति की स्थापना की l
वहीँ द्वापर युग में  द्वारिकाधीश श्रीकृष्ण ने विश्व के बड़े बड़े शक्तियों को कुरुक्षेत्र के मैदान में बुलाकर कर सबको समाप्त करा दिया और फिर पूरे विश्व में धर्म व शांति की स्थापना की l और वहीँ जब कलयुग के प्रथम चरण में ही पापाचार व अत्याचार अपने चरम पर पहुचने लगा धर्म का लोप होने लगा तब भारत के महान संत सतगुरु जयगुरूदेव (स्वामी तुलसीदास) जी महाराज ने परिवर्तन की आवाज़ लगा दी l
कहा कि कलयुग में कलयुग जायेगा और कलयुग में सतयुग आयेगा l और तब से वह स्वयं और अपने शिष्यों के जरिये भारत और पूरे विश्व में धर्म और शांति का पाठ निरंतर पढ़ा रहे हैं l</p>
<h5 style={{'font-weight':'bold'}} >'बड़ेला धाम भारतवर्ष' का उदेश्य</h5>
<p>तो हम आये हैं आपके बीच उन्हीं महान विभूतियों संत और महात्माओं की कहानियों को लेकर, लेकर उनके विचारों को, उनके दिव्य व आध्यात्मिक संदेशों को जन-जन तक पहुंचाने के लिये l</p>
<p>'बड़ेला धाम भारतवर्ष' प्रतिबध है कि अपने दर्शकों तक जो भी कथा और सत्संग वचन पहुंचाये वो सत्य हो उसमें किसी भी प्रकार से कोई गलत तथ्य न हो l
आप हमसे जुड़ सकते हैं जुड़ने के लिए क्लिक करें <a href={`${DOMAIN}/contact`}>contact us.</a></p>
          </div>
        </div>
      );
   }
}

export default About



// WEBPACK FOOTER //
// ./src/pages/About.jsx